import React from 'react'
import { UIButton } from '../buttons/ui-button'
import { UITooltip } from '../overlay/ui-tooltip'
import { UITypography } from '../display/ui-typography'
import { Moon, Sun } from 'lucide-react'
import { cn } from '../../lib/utils'
import { useDarkMode } from '../hooks/use-dark-mode'
import { UIBox } from './ui-box'

export interface UIFloatingToggleProps {
  className?: string
  onToggle?: () => void
  tooltipText?: string
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
}

const positionClasses = {
  'top-right': 'top-4 right-4',
  'top-left': 'top-4 left-4',
  'bottom-right': 'bottom-4 right-4',
  'bottom-left': 'bottom-4 left-4'
}

/**
 * 플로팅 다크모드 토글 버튼
 * 공통 다크모드 훅을 사용하여 일관된 동작을 제공합니다.
 */
export const UIFloatingToggle = React.forwardRef<
  HTMLButtonElement,
  UIFloatingToggleProps
>(({
  className,
  onToggle,
  tooltipText = "다크 모드 전환",
  position = 'top-right'
}, ref) => {
  const { toggle } = useDarkMode()

  const handleToggle = () => {
    toggle()
    onToggle?.()
  }

  return (
    <UIBox className={cn("fixed z-50", positionClasses[position], className)}>
      <UITooltip content={tooltipText}>
        <UIButton
          ref={ref}
          variant="outline"
          size="icon"
          className="rounded-full w-12 h-12 shadow-lg hover:shadow-xl transition-shadow bg-background/80 border-2"
          onClick={handleToggle}
        >
          <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-transform dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-transform dark:rotate-0 dark:scale-100" />
          <UITypography as="span" variant="small" className="sr-only">{tooltipText}</UITypography>
        </UIButton>
      </UITooltip>
    </UIBox>
  )
})

UIFloatingToggle.displayName = "UIFloatingToggle"